import type {
  IConnectElementSupplementalFunction,
  SupplementalFunctionKey,
} from '../connect/ConnectElementSupplementalFunctions';
import {DeferredPromise} from '../utils/DeferredPromise';
import {getStronglyTypedEntries} from '../utils/getStronglyTypedEntries';
import type UILayerMessagePort from './UILayerMessagePort';

export const generateSupplementalFunctionsProxy = (
  valuesToDefine: Partial<Record<SupplementalFunctionKey, boolean>>,
  port: UILayerMessagePort,
): IConnectElementSupplementalFunction => {
  const obj: IConnectElementSupplementalFunction = {};

  getStronglyTypedEntries(valuesToDefine).forEach(([key, value]) => {
    if (!value) {
      return;
    }

    obj[key] = (...args: any[]) => {
      const deferredPromise = new DeferredPromise<any>();

      port.callSupplementalFunction(
        {
          values: args,
          functionKey: key,
        },
        deferredPromise,
      );

      return deferredPromise.promise;
    };
  });

  return obj;
};
